<template>
<div>
  <div v-if="showTopNav" class="view-title">
    <div class="back-button">
      <div>
        <img
          src="../assets/backarrow.svg"
          alt="back"
          height="30px"
          v-touch:tap="backToSettings"/>
        <p>{{ $t('commons.back') }}</p>
      </div>
    </div>
  </div>

  <!-- h1 say: "Please Fix me! I'm hidden and only used to create a top margin -->
  <h1 v-if="showTopNav">Beacon id record</h1>

  <BeaconId @scanView="hideTopNav"></BeaconId>

  <div v-if="beaconRecorded">
    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
  </div>
</div>
</template>

<script>
import BeaconId from '../components/BeaconId.vue';

export default {
  components: {
    BeaconId,
  },
  data() {
    return {
      beaconRecorded: false,
      beaconAssigned: {},
      showTopNav: true,
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'getBeaconInfo') {
        this.beaconAssigned = mutation.payload;
        // Do whatever makes sense now
        if (state.status === 'success') {
          this.complex = {
            deep: 'some deep object',
          };
        }
      }
    });
  },
  watch: {
    beaconAssigned(nVal) {
      this.beaconRecorded = true;
      this.$store.dispatch('getOperatorTimesheet', nVal.beaconID);
    },
  },
  methods: {
    backToSettings() {
      this.$router.push('settings');
    },
    hideTopNav(evt) {
      this.showTopNav = !evt;
    },
  },
};
</script>

<style scoped>
  .view-title {
    display: grid;
    grid-template-columns: 2fr 8fr 2fr;
    background-color: cornflowerblue;
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
  }

  .back-button {
    margin-top: 1vh;
    margin-bottom: 1vh;
  }

  .back-button > div > p {
    margin: 0;
    font-size: 12px;
    color: #ffffff;
    margin-top: -6px;
  }

  /******************************************************************
  *                      CIRCLE CHECK MARK                          *
  *******************************************************************/

  /* Circle loader with checkmark completed state: by https://codepen.io/scottloway/pen/zqoLyQ */
  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: scale3d(2.1, 2.1, 1);
    }
    50% {
      transform: scale3d(3.1, 3.1, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px #7ac142;
    }
  }
</style>
